import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { RegnExamDataComponent } from '../regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';
import { DatePipe } from '@angular/common';
import { StudentDetailsComponent } from '../student-details/student-details.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-search-regn-forms',
  templateUrl: './search-regn-forms.component.html',
  styleUrls: ['./search-regn-forms.component.scss']
})
export class SearchRegnFormsComponent implements OnInit {
  SearchRegnForm: FormGroup;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  courseList: any;
  filteredcourseList: any;
  SessionFilterList: any;
  sessionList: any;
  filteredStreamList: any;
  streamList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  genderList: any;
  filteredGenderList: any;
  categoryList: any[];
  filteredCategoryList: any[];
  ListOfMedium: any;
  filteredListOfMedium: any;
  nationalityList: any;
  filteredNationalityList: any;
  religionList: any;
  filteredReligionList: any;
  filteredCollegeList: any;
  collegeList: any;
  GridData: any;
  Table = false;
  Table2=false;
  SubBtn = true
  ExmBtn = true
  ListOfStuStatus
filteredListOfStuStatus
  selectedRow: any | null = null;
  datePipe: DatePipe = new DatePipe('en-US');
  GridData2: any;
  GridRejectedData2: any;
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    public datepipe: DatePipe,    private location: Location,
    private dialog: MatDialog,public router: Router
  ) {
    this.APIService = environment.serviceUrl;
  }
  sortedColumn: string = '';
  sortDirection: string = 'asc';
  ngOnInit(): void {
    this.Table = false;
    this.Table2=false;
    this.SubBtn = true;
    this.ExmBtn = true;
    this.SearchRegnForm = this.fb.group({
      RgNo: new FormControl(''),
      SnNo: new FormControl(''),
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
      Name: new FormControl(''),
      Sex: new FormControl(''),
      Caste: new FormControl(''),
      Medium: new FormControl(''),
      Cate: new FormControl(''),
      StrCode: new FormControl(''),
      RgNation: new FormControl(''),
      RgImg: new FormControl(''),
      RgReli: new FormControl(''),
      RgStatus: new FormControl(''),
      RgUID: new FormControl(''),
      RgId: new FormControl(''),
      StudentType: new FormControl('')
    });

    this.getCourseData();
    this.fetchSession();
    this.getBranch();
    this.fetchConstiCate();
    this.fetchGender();
    this.fetchCast();
    this.fetchListOfMedium();
    this.fetchNationality();
    this.fetchReligion();
    this.getCollegeData();
    this.fetchListOfStuType();
  }
  back(){
    this.SearchRegnForm.reset();
    this.Table = false
    this.Table2=false
  }
  sortData(column: string) {
    if (this.sortedColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
  
    this.GridData.sort((a, b) => {
      const valA = a[this.sortedColumn];
      const valB = b[this.sortedColumn];
  
      // Handle string comparison
      if (typeof valA === 'string' && typeof valB === 'string') {
        return this.sortDirection === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
      }
  
      // Handle numeric comparison
      return this.sortDirection === 'asc' ? valA - valB : valB - valA;
    });
  }
  scrollToId(id: string) {
    const element = document.getElementById(id);
    if (element) {
        const table = document.getElementById('table');
        if (table) {
            table.scrollLeft = element.offsetLeft - table.offsetLeft;
            window.scrollTo({
              behavior: 'smooth' // Optional: for smooth scrolling
          });
        }
    }
  //  document.getElementById(id).scrollTo();
   
  }


  getCourseData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredcourseList = this.courseList.slice();
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = ''; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

  getBranch(){
    this.spinner.show();
    let payload = {};
    payload['CoCode'] = '';
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe((res) => {
      this.spinner.hide();
      if(res.data.length > 0){
      }
      else{
      }
      if (res.status) {
        this.streamList = res.data;
        this.filteredStreamList = this.streamList.slice();
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  fetchConstiCate() {
    const payload = {};
    payload['CdType'] = 'CT';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchGender() {
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchCast() {
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        //this.castGene(payload)
      } else {
      }
    });
  }

  fetchListOfMedium() {
    const payload = {};
    payload['CdType'] = 'ME';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMedium = res.data;
        this.filteredListOfMedium = this.ListOfMedium.slice();
      } else {
      }
    });
  }


  fetchListOfStuType() {
    const payload = {};
    payload['CdType'] = 'SStat';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfStuStatus= res.data;
        this.filteredListOfStuStatus = this.ListOfStuStatus.slice();
      } else {
      }
    });
  }

  fetchNationality() {
    const payload = {};
    payload['CdType'] = 'NA';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchReligion() {
    const payload = {};
    payload['CdType'] = 'Reg';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.religionList = res.data;
        this.filteredReligionList = this.religionList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  getCollegeData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  getData(){
  
    this.GridData = []
    this.Table = false
    this.spinner.show();
    const payload = this.SearchRegnForm.value;
    if(payload.StudentType == ''){
     
      this.umsService.SearchRegn(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide();
          this.Table = true;
          this.Table2 =false;
          this.GridData = res.data
        }
        else{
          this.spinner.hide();
          this.Table = false;
          this.Table2 =false;
          this.GridData = []
        }
      
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.Table = false;
        this.Table2 =false;
        this.GridData = []
      })
    }
   else{
    this.getRejectedData(payload.StudentType)
   }
  }

  Exam(){
    const dialogRef = this.dialog.open(RegnExamDataComponent, {
      width: '130vh',
      // height: '50vh',
      data: this.selectedRow,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getData();
    });
  }

  selected(data){
    this.selectedRow = data;
    if(data.ExamsAvailable == 0){
      this.SubBtn = true;
      this.ExmBtn = true
    }
    else{
      this.SubBtn = false
      this.ExmBtn = false
    }
    
  }

  Sub(){
    let data = {};
    data['data'] = this.selectedRow;
    data['type'] = 'All';
    const dialogRef = this.dialog.open(RegnExamSubComponent, {
      width: '130vh',
      disableClose: true,
      data,
      
    });
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }


  View(){
    const dialogRef = this.dialog.open(StudentDetailsComponent, {
      width: '130vh',
      // height: '50vh',
      data: this.selectedRow,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getData();
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
  


  getstuid(){
    this.selectedRow;
    let payload = {}
    payload['StuRgNo']= this.selectedRow.RgNo;
    payload['StuId']= '';
    this.umsService.getStuId(payload).subscribe((res) => {
      this.spinner.hide();
      this.router.navigate(['student-profile'],
      { state: { 
        // ScrutinyLevel: this.selectedRow.ScrutinyLevel,
        // UserId: data.UserId,
        // ScrutinyId: data.ScrutinyId,
        StudentId: res.data[0].StuId,
        from:'report'
        // LoginFullName: data.LoginFullName,
        // StuFirstName: data.StuFirstNameEng,
        // StuMidName: data.StuMidNameEng,
        // StuLastName: data.StuLastNameEng,
        // CoCode: data.CoCode,
        // CgCode: data.CgCode,
        // SessionId: data.SessionId
      }}
      ); 
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
    
  }



  getRejectedData(item){

    // if(item.CdDesc == 'Rejected'){
      this.GridRejectedData2 = []
      this.Table = false
      this.spinner.show();
      const payload = this.SearchRegnForm.value;
      payload['StudentType']=item;
      this.umsService.SearchRejectRegn(payload).subscribe((res) => {
        this.spinner.hide();
        this.Table2 = true;
        this.Table =false;
        this.GridRejectedData2 = res.data
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.Table = false;
        this.GridRejectedData2 = []
      })
  }


  Back(){
    this.goBack();
   }
   goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  dowload(data){
    this.getstuid2(parseInt(data.RgNo),data)
   
  }

  getstuid2(RgNo,data){
    let payload = {};
    payload['StuRgNo'] = RgNo;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      this.router.navigate(['download-details'],
    { queryParams: { 
      StuId: res.data[0].StuId,
      RgNo: parseInt(data.RgNo),
      SessionId: data.RgSnNo
    }}); 
    })
  }
}
